"use client";

import { motion } from "motion/react";

import { cn } from "@/lib/utils";

import { EASE_IN_OUT } from "./reveal";

// =============================================================================

type DrawLineProps = {
  className?: string;
  delay?: number;
  /** Draw on mount instead of when entering the viewport */
  immediate?: boolean;
};

/**
 * Horizontal 1px separator drawing itself from the left.
 */
export function DrawLine({
  className,
  delay = 0.2,
  immediate = false,
}: DrawLineProps) {
  const visible = { scaleX: 1 };

  return (
    <motion.div
      aria-hidden
      initial={{ scaleX: 0 }}
      {...(immediate
        ? { animate: visible }
        : {
            whileInView: visible,
            viewport: { once: true, margin: "0px 0px -8% 0px" },
          })}
      transition={{ duration: 1.4, delay, ease: EASE_IN_OUT }}
      className={cn("h-px w-full origin-left bg-line", className)}
    />
  );
}

// =============================================================================
